import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Box, Typography, Paper } from "@mui/material";

const ErrorPage = () => {
    const error = useSelector(({ message }) => message.error);
    const [timer, setTimer] = useState(5);

    setTimeout(() => {
        setTimer(timer - 1);
    }, 1000);

    setTimeout(() => {
        window.parent.location.href = `${process.env.REACT_APP_WM_URL}/triviaHome`;
    }, 4000);

    return (
        <Box
            sx={{
                display: "flex",
                height: "100%",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <Paper
                sx={{
                    padding: "2rem",
                    backgroundColor: "black",
                    color: "#fff",
                    border: "3px solid #00b3e2",
                }}
            >
                <Typography
                    variant="h5"
                    align="center"
                    dangerouslySetInnerHTML={{
                        __html: `${error}`,
                    }}
                ></Typography>
                <Typography
                    variant="body2"
                    align="center"
                >{`Redirecting to Trivia Home in ${timer} seconds`}</Typography>
            </Paper>
        </Box>
    );
};

export default ErrorPage;
